import { isMobile } from 'react-device-detect';
import { MobileHelperEnabled } from '../db/local_storage';
import { IRobotConnection } from '../types/types';
import { LocalStorageGenerator } from '../utils';
import { getNewSimRobotConnection, useNewSimulator } from '../services/new-sim/settings';

export const getProductionRobotConnection = (): IRobotConnection => ({
  hostname: isMobile && MobileHelperEnabled.get() ? 'year.rogoag.com' : 'local.rogoag.com',
  endpoint: '/',
  port: 9090,
  insecure: false,
});

const defaultRobotConnection: IRobotConnection = useNewSimulator()
  ? getNewSimRobotConnection()
  : getProductionRobotConnection();

export const RobotConnectionStore = LocalStorageGenerator<IRobotConnection>('robot_connection', defaultRobotConnection);
